'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.beginningOfDay;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/beginningOfDay.js
// module id = 476
// module chunks = 0